<template>
	<div class="item-container display-flex flex-row flex-align-center flex-justify-space-between width-100">
		<div class="display-flex flex-row flex-align-center">
			<div class="card-container flex-centerize mr-6">
				<v-img :src="icon" />
			</div>
			<div class="display-flex flex-column flex-justify-center">
				<h3 class="reg">{{ name }}</h3>
				<h5 v-if="description" class="description">{{ description }}</h5>
			</div>
		</div>
		<AppTooltip :noArrow="!requestMode" :text="tooltipText">
			<AnemicButton rounded :loading="isLoading" :disabled="cantDelete" class="pa-0 close-button" @click="onClick">
				<SIcon :name="cantDelete ? 'cant-remove-favorite-app' : 'remove-favorite-app'" height="18" width="18" />
			</AnemicButton>
		</AppTooltip>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'ManageAppsFavoriteAppsListItem',
	components: {},
	props: {
		id: { type: Number },
		icon: { type: String },
		name: { type: String },
		cantDelete: { type: Boolean },
		tooltipText: { type: String },
		description: { type: String },
		requestMode: { type: Boolean },
	},
	computed: {},
	methods: {
		...mapActions(['deleteFavoriteApp', 'deleteFavoriteAppRequest']),
		onClick() {
			if (this.requestMode) {
				this.removeAppRequest();
			} else {
				this.removeFavoriteApp();
			}
		},
		async removeFavoriteApp() {
			this.isLoading = true;
			try {
				await this.deleteFavoriteApp({ appId: this.id });
			} catch {
				this.$toast.error('Failed removing app, please try again later');
			} finally {
				this.isLoading = null;
			}
		},
		async removeAppRequest() {
			this.isLoading = true;
			try {
				await this.deleteFavoriteAppRequest({ id: this.id });
			} catch {
				this.$toast.error('Failed removing app, please try again later');
			} finally {
				this.isLoading = null;
			}
		},
	},
	data() {
		return { isLoading: null };
	},
};
</script>

<style scoped lang="scss">
.item-container {
	height: 74px;
	border-bottom: 1px solid var(--border-color);
}
.card-container {
	width: 45px;
	height: 45px;
	padding: 10px;
	border-radius: 10px;
	background: var(--bg-color);
	border: 1px solid #abb2bd6e;
	box-shadow: 0px 1px 2px #80899c4d;
}
.description {
	color: #a3a3a3;
}
.close-button {
	height: 18px !important;
	font-size: 12px !important;
	min-width: 18px !important;
	background: var(--white) !important;
}
</style>
